export function Calc(price: number) {
  const result = Math.trunc(((price || 0) * 100) / 90);
  return result.toLocaleString("ru-RU") + " ₽";
}
